import { useState } from 'react';
import styles from '../../../pages/VerifyPhone/VerifyPhone.module.css';
import { useTheme } from '../../hooks/ThemeContext';
import { useLogo } from '../../hooks/LogoContext';
import { useModal } from '../../hooks/modalContext';
import { unsubscribeCreditBuilder } from '../../../auth/_requests';
import { useAuth } from '../../../auth/Auth';
import toast from 'react-hot-toast';

const UnsubscribeCredit = () => {
  const { theme } = useTheme();
  const { auth } = useAuth();
  const { setModal, modalState } = useModal();
  const { logoUrl, logoLoading } = useLogo();
  const [loading, setLoading] = useState(false);

  const toastStyles = {
    background: theme === 'dark' ? '#000' : '#fff',
    color: theme === 'dark' ? '#f5f5f5' : '#020b28',
    border: theme === 'dark' ? '1px solid #f5f5f5' : 'none',
  };

  const handleRemove = async () => {
    try {
      setLoading(true);
      await unsubscribeCreditBuilder(auth?.data.token, modalState?.tenantBuildingId || '');
      toast.remove();

      toast.success('You have successfully unsubscribed from Credit Builder for this property.', {
        duration: 8000,
        style: toastStyles,
      });
      setTimeout(() => {
        window.location.reload();
      }, 5000);
      setModal(null);
    } catch (error) {
      toast.error('Something went wrong while unsubscribing. Please try again later.', {
        duration: 6000,
        style: toastStyles,
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <section className={styles.section}>
      <main className={`${styles.main} ${theme === 'dark' ? styles.mainDark : ''}`}>
        {loading ? (
          <p className={`${styles.loadingText} ${theme === 'dark' ? styles.loadingTextWhite : ''}`}>
            Loading...
          </p>
        ) : (
          <>
            {!logoLoading && <img src={logoUrl} className={styles.logo} alt='TenantPay Logo' />}

            <button
              className={`${styles.cross} ${theme === 'light' ? styles.crossLight : ''}`}
              onClick={() => setModal(null)}
              aria-label='Close modal'
            >
              ✕
            </button>

            <div className={`${styles.headingBox} gap-[20px]`}>
              <h2
                className={`${styles.heading} ${
                  theme === 'dark' ? styles.headingDark : ''
                } text-center text-[24px]`}
              >
                Unsubscribe Credit Builder
              </h2>
              <p className={styles.subHead}>
                Are you sure you want to unsubscribe the Credit Builder for this property?
              </p>
              <p className={styles.subHead}>
                {' '}
                You will not be able to re-subscribe using this property again.
              </p>
            </div>

            <div className={styles.buttonContainer}>
              <button className={styles.cancelButton} onClick={() => setModal(null)}>
                Cancel
              </button>
              <button className={styles.confirmButton} onClick={handleRemove} disabled={loading}>
                {loading ? 'Removing...' : 'Continue'}
              </button>
            </div>
          </>
        )}
      </main>
    </section>
  );
};

export default UnsubscribeCredit;
